/**
 * @Description 客流画像
 */

import { FC, useMemo } from 'react';
import styles from './index.module.less';
import Header from '../Header';
import { IconFont } from '@/components';
import PPTGaugeChart from '../GaugeChart';
import GenderRate from '../GenderRate';
import PPTPieChart from '../PieChart';
import { isNotEmpty } from '@lhb/func';

const PassengerFlowPortrait:FC<any> = ({
  rangeName,
  flow,
  normalInfoVO,
  workdayAndHolidayInfoVO
}) => {
  const data = useMemo(() => {
    return ([
      { name: '客群画像', level: normalInfoVO?.complex?.maleToFemaleRatio ? `${normalInfoVO?.complex?.maleToFemaleRatio}多` : '-', icon: 'iconic_kequn' },
      { name: '学历', level: normalInfoVO?.complex?.education || '-', icon: 'iconic_benke' },
      { name: '消费水平', level: normalInfoVO?.complex?.consumptionLevel || '-', icon: 'iconic_xiaofei1' },
      { name: '客群偏好', level: normalInfoVO?.complex?.customerPreference || '-', icon: 'iconic_pianhao' },
    ]);
  }, [normalInfoVO]);

  const GuageData = useMemo(() => {
    if (!flow) return 1;
    const { workdayFlow, holidayFlow, dayFlow } = flow; // 后端给的是 srting 类型
    if (workdayFlow && holidayFlow && dayFlow) {
      return (Number(dayFlow) / (Number(workdayFlow) + Number(holidayFlow) + Number(dayFlow))).toFixed(2);
    }
    return 1;
  }, [flow]);

  const wordDaySexRate = useMemo(() => {
    if (workdayAndHolidayInfoVO?.sex && workdayAndHolidayInfoVO?.sex.workday) {
      const men = workdayAndHolidayInfoVO?.sex.workday.filter(item => item.name === '男')[0];
      const women = workdayAndHolidayInfoVO?.sex.workday.filter(item => item.name === '女')[0];
      if (men && women) {
        return { maleRate: (men.value * 100).toFixed(2), femaleRate: (women.value * 100).toFixed(2) };
      } else {
        return { maleRate: 0, femaleRate: 0 };
      }
    } else {
      return { maleRate: 0, femaleRate: 0 };
    }
  }, [workdayAndHolidayInfoVO]);

  const holidaySexRate = useMemo(() => {
    if (workdayAndHolidayInfoVO?.sex && workdayAndHolidayInfoVO?.sex.holiday) {
      const men = workdayAndHolidayInfoVO?.sex.holiday.filter(item => item.name === '男')[0];
      const women = workdayAndHolidayInfoVO?.sex.holiday.filter(item => item.name === '女')[0];
      if (men && women) {
        return { maleRate: (men.value * 100).toFixed(2), femaleRate: (women.value * 100).toFixed(2) };
      } else {
        return { maleRate: 0, femaleRate: 0 };
      }
    } else {
      return { maleRate: 0, femaleRate: 0 };
    }
  }, [workdayAndHolidayInfoVO]);

  return (
    <div className={styles['page']}>
      <Header title={`客流画像 — ${rangeName}`}/>

      <div className={styles['content']}>
        <div className={styles['top']}>
          {isNotEmpty(flow?.cityRank) ? <span>{`客流指数,同城地区商场排名第${flow?.cityRank}，`}</span> : <></>}
          {isNotEmpty(flow?.multiple) ? `节假日客流量是工作日的${flow?.multiple}倍。` : <></>}
        </div>

        <div className={styles['bottom']}>
          <div className={styles['left']}>
            <div className={styles['word']}>
              <div className={styles['title']}>
                客流指数
                <IconFont iconHref='iconic_info' className={styles['title-icon']}/>
              </div>

              <div className={styles['workday']}>
                <div className={styles['workday-count']}>{flow?.workdayFlow}</div>
                <div className={styles['workday-title']}>工作日日均客流(人次)</div>
              </div>

              <div className={styles['workday']}>
                <div className={styles['workday-count']}>{flow?.holidayFlow}</div>
                <div className={styles['workday-title']}>节假日日均客流(人次)</div>
              </div>
            </div>

            <div className={styles['gauge']}>
              <PPTGaugeChart className={styles['gauge']} value={GuageData} title={flow?.dayFlow}/>
            </div>

            <div className={styles['left-bottom']}>
              <GenderRate title='工作日' value={wordDaySexRate.maleRate} femaleValue={wordDaySexRate.femaleRate}/>
              <GenderRate title='节假日' value={holidaySexRate.maleRate} femaleValue={holidaySexRate.femaleRate}/>
            </div>
          </div>

          <div className={styles['right']}>

            <div className={styles['right-top']}>
              <div className={styles['title']}>客流评估</div>
              <div className={styles['card-box']}>
                {data.map((item, index) => {
                  return (
                    <div className={styles['card']} key={index}>
                      <div>
                        <IconFont iconHref={item.icon} className={styles['card-icon']}/>
                      </div>
                      <div className={styles['card-level']}>{item.level}</div>
                      <div className={styles['card-name']}>{item.name}</div>
                    </div>
                  );
                })}
              </div>
            </div>

            <div className={styles['right-bottom']}>
              <div className={styles['chart']}>
                <PPTPieChart
                  title='客流学历分布'
                  type='circle'
                  height={280}
                  seriesData={[{
                    data: normalInfoVO?.education || [],
                  }]}
                  config={{
                    legend: {
                      height: 190,
                      itemGap: 16,
                      left: '300px'
                    },
                    title: {
                      left: 68,
                      textStyle: {
                        color: '#222222',
                        fontWeight: 500,
                        fontFamily: 'PingFangSC, PingFang SC',
                        fontSize: 24,
                        lineHeight: 33,
                        width: 144,
                      }
                    }
                  }}/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PassengerFlowPortrait;
